import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { IBanco } from '../interfaces/banco.interface';
import { BancoService } from '../services/banco.service';
import { MatDialog } from '@angular/material/dialog';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-abc-bancos-form',
  templateUrl: './abc-bancos-form.component.html',
  providers: [MessageService]
})
export class AbcBancosFormComponent implements OnInit, OnChanges {
  @Input() banco: IBanco | null = null;
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();
  
  form!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private bancoService: BancoService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['banco']) {
      this.initForm();
      if (changes['banco'].currentValue) {
        this.loadBanco();
      }
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      banco: [{ value: '', disabled: !!this.banco }, [Validators.required]],
      nombre: [''],
      tipoTarjeta: [''],
      numeroCuenta: [''],
      cuentaContable: [''],
      iOrigenMov: [0],
      iOrigenDisp: [0]
    });
  }

  loadBanco(): void {
    if (this.banco) {
      this.form.patchValue({
        banco: this.banco.banco,
        nombre: this.banco.nombre,
        tipoTarjeta: this.banco.tipoTarjeta,
        numeroCuenta: this.banco.numeroCuenta,
        cuentaContable: this.banco.cuentaContable,
        iOrigenMov: this.banco.iOrigenMov,
        iOrigenDisp: this.banco.iOrigenDisp
      });
    }
  }

  create(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    
    this.bancoService.createBanco(formData).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: 'Banco creado correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.message || 'Error al crear el banco'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al crear el banco'
        });
        this.loading = false;
      }
    });
  }

  update(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    
    this.bancoService.updateBanco(formData).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: 'Banco actualizado correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.message || 'Error al actualizar el banco'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al actualizar el banco'
        });
        this.loading = false;
      }
    });
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'bancos',
        sClave: `${this.form.get('banco')?.value}`,
        sNombre: this.form.get('nombre')?.value,
        sTipo: 'Opcion'
      }
    });
  }
}
